export default __webpack_public_path__ + "static/media/banner.39d6f9d4.png";